export default {
  signIn: 'เข้าสู่ระบบ',
  signOut: 'ออกจากระบบ',
  points: 'คะแนน',
  hyattSignInButton: 'เข้าสู่ระบบ World of Hyatt',
};
